export default "__VITE_ASSET__2c6d04d3__"